import { IoTimeSharp } from "react-icons/io5";
import { FaExternalLinkAlt } from "react-icons/fa";
import { format } from "timeago.js/dist/timeago.min.js";
import { Link } from "react-router-dom";

const typeIcons = {
  SHIPMENT_STATUS_UPDATED: <IoTimeSharp />,
};

const parseShipmentMessage = (message) => {
  const match = message.match(/order\s+([\w-]+).*updated to:\s*([a-z_]+)/i);

  if (!match) {
    return { orderId: null, status: null };
  }

  const orderId = match[1];
  const statusRaw = match[2];

  const statusFormatted = statusRaw
    .split("_")
    .map((w) => w[0].toUpperCase() + w.slice(1))
    .join(" ");

  return { orderId, status: statusFormatted };
};

export function NotificationItem({ notif, onClick }) {
  const icon = typeIcons[notif.type] || typeIcons.default;
  const { orderId, status } = parseShipmentMessage(notif.message);

  return (
    <li
      onClick={() => onClick(notif.notificationId)}
      className={`flex items-center justify-between space-x-3 px-3 py-2 rounded cursor-pointer transition-colors ${
        notif.read ? "bg-white" : "bg-slate-50 hover:bg-slate-200"
      }`}
    >
      {/* Icon + Message */}
      <div className="flex items-start space-x-3 flex-1">
        <div className="bg-slate-400 text-lg rounded-md p-1 flex items-center justify-center">
          <div className="text-white">{icon}</div>
        </div>

        <div className="flex-1">
          {orderId && status ? (
            <p
              className={`text-xs ${
                notif.read
                  ? "text-gray-800 font-normal"
                  : "text-gray-900 font-semibold"
              }`}
            >
              Order {orderId} is now {status}.
            </p>
          ) : (
            <p
              className={`text-xs ${
                notif.read
                  ? "text-gray-800 font-normal"
                  : "text-gray-900 font-semibold"
              }`}
            >
              {notif.message}
            </p>
          )}
          <div className="mt-1">
            <p className="text-xs text-gray-500">{format(notif.timestamp)}</p>
          </div>
        </div>
      </div>

      {/* Go to order button */}
      {orderId && (
        <Link
          to={`/dashboard/orders/${orderId}`}
          onClick={(e) => e.stopPropagation()} // prevent marking as read
          className="ml-3 text-gray-500 hover:text-gray-700 text-sm flex items-center"
          title="View Order"
        >
          <FaExternalLinkAlt className="ml-1" />
        </Link>
      )}
    </li>
  );
}
